import { ageLabel } from "@/lib/patient";
import { dateTimeBR } from "./MeetingBits";

/** Bloco de um paciente na ata: usado na prévia antes do encerramento e na ata salva. */
export const DiscussedBlocks = ({ items = [], testId = "minutes-discussed" }) => (
  <ol data-testid={testId} className="space-y-4">
    {items.map((d) => (
      <li
        key={d.patient_id}
        data-testid={`minutes-patient-${d.patient_id}`}
        className="rounded-xl border border-border px-4 py-3.5"
      >
        <p className="text-[15.5px] font-semibold text-ink-900">
          {d.patient_name}
          <span data-testid={`minutes-age-${d.patient_id}`} className="ml-2 text-[13.5px] font-normal text-ink-500">
            {ageLabel(d)}
          </span>
        </p>
        <p data-testid={`minutes-date-${d.patient_id}`} className="mt-1 text-[13.5px] text-ink-500">
          Data da discussão: {dateTimeBR(d.discussed_at)}
        </p>

        {d.flags_opened?.length ? (
          <p className="mt-1.5 text-[13.5px] text-ink-600">Marcações abertas: {d.flags_opened.join(", ")}</p>
        ) : null}
        {d.flags_kept?.length ? (
          <p className="mt-1 text-[13.5px] text-ink-600">Marcações mantidas: {d.flags_kept.join(", ")}</p>
        ) : null}
        {d.flags_closed?.length ? (
          <p className="mt-1 text-[13.5px] text-ink-600">Marcações encerradas: {d.flags_closed.join(", ")}</p>
        ) : null}

        {d.notes ? (
          <p data-testid={`minutes-notes-${d.patient_id}`} className="mt-2 text-[14px] text-ink-800">
            <span className="font-semibold">Observações registradas:</span> {d.notes}
          </p>
        ) : null}

        {(d.comments || []).length ? (
          <ul data-testid={`minutes-comments-${d.patient_id}`} className="mt-2 space-y-1.5">
            {d.comments.map((c) => (
              <li key={c.id} className="rounded-lg bg-sand/50 px-3 py-2 text-[14px] text-ink-800">
                {c.text}
                <span className="mt-0.5 block text-[12.5px] text-ink-500">
                  {dateTimeBR(c.created_at)}
                  {c.author_name ? ` · ${c.author_name}` : ""}
                </span>
              </li>
            ))}
          </ul>
        ) : null}

        {!d.has_records ? (
          <p data-testid={`minutes-no-records-${d.patient_id}`} className="mt-2 text-[13.5px] text-ink-500">
            Sem observações registradas.
          </p>
        ) : null}

        <p className="mt-2 text-[14px] text-ink-700">
          Definições e encaminhamentos:{" "}
          {d.decisions || (d.keep_current_conduct ? "Mantida a conduta atual" : "—")}
        </p>
        {d.keep_current_conduct && d.decisions ? (
          <p className="mt-1 text-[13.5px] font-semibold text-ink-700">Mantida a conduta atual</p>
        ) : null}

        {(d.reallocations || []).map((r, i) => (
          <p key={i} className="mt-1 text-[13.5px] text-ink-600">
            {r.role_label}: {r.previous_name || "não definido"} → {r.new_name || "não definido"}
          </p>
        ))}
      </li>
    ))}
  </ol>
);
